// document.addEventListener("DOMContentLoaded", function () {
//   const copyButtons = document.querySelectorAll(".share-button__copy");

//   copyButtons.forEach((button) => {
//     button.addEventListener("click", function () {
//       const shareSection = button.closest(".share--button");
//       const inputField = shareSection.querySelector(".field__input");
//       const shareMessage = shareSection.querySelector(".share-button__message");
//       const fallback = shareSection.querySelector(".share-button__fallback");

//       const customMessage =
//         shareSection.getAttribute("data-message") || "URL copied to clipboard!";

//       inputField.select();
//       inputField.setSelectionRange(0, 99999);

//       navigator.clipboard
//         .writeText(inputField.value)
//         .then(() => {
//           setTimeout(() => {
//             shareSection.classList.add("clicked");
//             fallback.classList.add("active");
//           }, 500);

//           shareMessage.textContent = customMessage;
//           shareMessage.classList.remove("hidden");

//           let hideTimeout;

//           const startHideTimer = () => {
//             hideTimeout = setTimeout(() => {
//               shareSection.classList.remove("clicked");
//               fallback.classList.remove("active");
//             }, 4000);
//           };

//           const stopHideTimer = () => clearTimeout(hideTimeout);

//           // Start the hide timer
//           startHideTimer();

//           // Pause when hovering
//           fallback.addEventListener("mouseenter", stopHideTimer);
//           // Resume when leaving
//           fallback.addEventListener("mouseleave", startHideTimer);
//         })
//         .catch((err) => {
//           console.error("Failed to copy: ", err);
//         });
//     });
//   });
// });

// const shareButton = document.querySelector(".share--button");
// const shareDialog = document.querySelector(".share-dialog");

// shareButton.addEventListener("click", (event) => {
//   const shareUrl = shareButton.getAttribute("data-share-url");

//   if (navigator.share) {
//     navigator
//       .share({
//         title: "Share",
//         url: shareUrl, // Use the dynamic Shopify share URL
//       })
//       .then(() => {
//         console.log("Thanks for sharing!");
//       })
//       .catch(console.error);
//   } else {
//     shareDialog.classList.add("is-open");
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  const copyButtons = document.querySelectorAll(".share-button__copy");

  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const shareSection = button.closest(".share--button");
      const inputField = shareSection.querySelector(".field__input");
      const shareMessage = shareSection.querySelector(".share-button__message");
      const fallback = shareSection.querySelector(".share-button__fallback");

      // ✅ Use attribute or fallback to current page
      const customMessage =
        shareSection.getAttribute("data-message") || "URL copied to clipboard!";
      const shareUrl =
        button.getAttribute("data-share-url") || window.location.href;

      // ✅ Ensure input value is always the full URL
      if (inputField) {
        inputField.value = shareUrl;
        inputField.select();
        inputField.setSelectionRange(0, 99999);
      }

      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          setTimeout(() => {
            shareSection.classList.add("clicked");
            fallback.classList.add("active");
          }, 500);

          shareMessage.textContent = customMessage;
          shareMessage.classList.remove("hidden");

          let hideTimeout;

          const startHideTimer = () => {
            hideTimeout = setTimeout(() => {
              shareSection.classList.remove("clicked");
              fallback.classList.remove("active");
            }, 4000);
          };

          const stopHideTimer = () => clearTimeout(hideTimeout);

          startHideTimer();
          fallback.addEventListener("mouseenter", stopHideTimer);
          fallback.addEventListener("mouseleave", startHideTimer);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    });
  });

  const shareButton = document.querySelector(".share--button");
  const shareDialog = document.querySelector(".share-dialog");

  if (shareButton) {
    shareButton.addEventListener("click", (event) => {
      const copyBtn = shareButton.querySelector(".share-button__copy");
      const shareUrl =
        (copyBtn && copyBtn.getAttribute("data-share-url")) ||
        shareButton.getAttribute("data-share-url") ||
        window.location.href;

      if (navigator.share) {
        navigator
          .share({
            title: "Share",
            url: shareUrl,
          })
          .then(() => console.log("Thanks for sharing!"))
          .catch(console.error);
      } else {
        shareDialog.classList.add("is-open");
      }
    });
  }
});
